<ng-container *ngIf="isExternalUrl(); else isLocalUrl">
  <a
    role="link"
    [href]="url"
    [attr.target]="target"
    [attr.rel]="rel"
    [attr.class]="class"
    [attr.id]="id"
    [attr.style]="style"
    [attr.title]="title"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #isLocalUrl>
  <a
    *ngIf="location === 'footer'; else nonFooterTemplate"
    role="link local"
    [routerLink]="routerUrl"
    [attr.target]="target"
    [attr.class]="class"
    [attr.id]="id"
    [attr.style]="style"
    [attr.title]="title"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #nonFooterTemplate>
  <a
    role="link"
    [href]="routerUrl"
    [attr.target]="target"
    [attr.class]="class"
    [attr.id]="id"
    [attr.style]="style"
    [attr.title]="title"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #content>
  <img *ngIf="linkIconSrc" [src]="setImageUrl(linkIconSrc)" [class]="linkIconStyleClass" />
  <ng-content></ng-content>
  <ng-container *ngIf="location !== 'footer'">
    <ng-container *ngIf="!icon; else iconDefined">
      <mat-icon *ngIf="isDesktop(); else isNonDesktop" class="material-icons-sharp light" [attr.title]
        >system_update_alt</mat-icon
      >
      <ng-template #isNonDesktop>
        <mat-icon class="material-icons-sharp light" [attr.title]>keyboard_arrow_right</mat-icon>
      </ng-template>
    </ng-container>
    <ng-template #iconDefined>
      <mat-icon class="material-icons-sharp light manual-arrow" [attr.title]>keyboard_arrow_right</mat-icon>
    </ng-template>
  </ng-container>
</ng-template>
